module.exports = __webpack_public_path__ + "img/horizon.f7b55fd6.jpg";